<template>
<el-form :model="formPlan" ref="formPlan" :label-position="'top'">
    <el-form-item label="Selecciona una categoría" prop="idcategory" :rules="[
          {required: true, message: 'Este campo es obligatorio', trigger: 'change'}
        ]">
        <el-select v-model="formPlan.idcategory" placeholder="Seleccione" filterable class="w-100" @change="getPlans">
            <el-option v-for="item in listCategorys" :key="item.value" :label="item.text" :value="item.value"></el-option>
        </el-select>
    </el-form-item>

    <label class="mb-3">Selecciona el plan que mejor se adapte a tí</label>
    <empty v-if="plans.length==0"></empty>

    <div class="row" v-else>

        <el-form-item prop="idproducto" :rules="[
          {required: true, message: 'Falta seleccionar el plan', trigger: 'change'}
        ]">
            <el-radio-group v-model="formPlan.idproducto">
                <div v-for="(item, index) in plans" :key="index" class="col-sm-12">
                    <label class="option mb-2 p-2 pr-4 pt-4 pb-3 border">

                        <span class="option-control pt-4">
                            <span class="radio">
                                <el-radio :label="item.producto"></el-radio>
                            </span>
                        </span>
                        <span class="option-label  w-100 mr-1">
                            <span class="option-head">
                                <div class="option-title mb-1" v-html="item.descripcion"></div>
                            </span>
                            <div class="d-flex">
                              <h1 class="option-body pt-0 text-primary mb-0 mr-3" style="font-size:20px;" v-html="'S/' + item.pUnitario.toFixed(2)"></h1>
                              <span class="mb-0 badge badge-warning border rounded" style="font-size: 13px; font-style:normal">Plan: Mensual</span>
                            </div>

                        </span>

                    </label>
                </div>
            </el-radio-group>
        </el-form-item>

    </div>

    <div class="text-right">
        <button class="btn mb-3 mt-3 ml-2" @click.prevent="volver">Atras</button>
        <button class="btn outline-btn mb-3 mt-3 ml-2" @click.prevent="submitForm('formPlan')">Siguiente</button>
    </div>

</el-form>
</template>

<script>
import empty from "@/components/common/Empty"

export default {
    name: "Plan",
    props: {
        club: {
            type: Object,
            required: true,
            default: {}
        },
        setPlan: {
          type: Object,
            required: false,
            default: {}
        }
    },
    components: {
        empty
    },
    data: () => ({
        formPlan: {
            idcategory: null,
            idproducto: null
        },
        listCategorys: [],
        plans: []
    }),
    methods: {
        volver() {
            this.$emit("resVolver", 0)
        },

        async getCategories() {
            await axios.post(`${process.env.API2}/v1/abs/listarCategoriaVehiculo`, {
                value: this.club.idseat
            }).then((res) => {
                this.listCategorys = res.data
            })
        },

        async getPlans() {
          this.formPlan.idproducto = null
            await axios.post(`${process.env.API2}/v1/abs/listarServicioAbonado`, {
                area: this.club.idseat,
                catalogoVehiculoId: this.formPlan.idcategory
            }).then((res) => {
                //console.log(res.data)
                this.plans = res.data
            })

        },

        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (!valid)
                    return false
                let plan = this.plans.find(item => item.producto === this.formPlan.idproducto)
                plan.idcategory = this.formPlan.idcategory;
                plan.idproducto = this.formPlan.idproducto;
                //this.formPlan = plan
                this.$emit("resPlan", plan)
            })
        }
    },
    created() {
        this.getCategories()

        //console.log(this.setPlan)
    }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/abonados/Plan.vue